import React from 'react';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
    Box,
    AppBar,
    Tabs,
    Tab,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
import usadegree from '../img/usadegree.jpeg';
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';

const Rusa = () => {

    const [value, setValue] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const benefits = [
        {
            title: "World’s leading economy",
            // description: "America offers a lower cost of living and tuition fees compared to other popular study destinations.",
            icon: <PaidIcon />
        },
        {
            title: "Cosmopolitan cities with great quality of life",
            // description: "Students can engage in groundbreaking research and collaborate with leading experts.",
            icon: <SchoolIcon />
        },
        {
            title: "Immense demand for workers of all skills",
            // description: "America provides pathways for international students to apply for permanent residency.",
            icon: <PublicIcon />
        },
        {
            title: "Melting pot of cultures",
            // description: "Experience vibrant student life, cultural diversity, and a wide range of extracurricular activities.",
            icon: <EmojiPeopleIcon />
        },
        {
            title: "Huge opportunity for professional growth",
            // description: "America is known for its safety and welcoming atmosphere, providing peace of mind to students.",
            icon: <LiveHelpIcon />
        },
        {
            title: "High salaries with incredible savings",
            // description: "International students can work part-time while studying, gaining valuable experience.",
            icon: <SchoolIcon />
        },
    ];

    return (
        <div>
            <Webhead />
            <div>
                {/* <StudyInAmerica /> */}
                <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

                    <Box
                        sx={{
                            backgroundImage: `url(${usadegree})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            color: 'white',
                            padding: '100px 20px',
                            textAlign: 'center',
                        }}
                    >
                        <Typography variant="h4" gutterBottom>
                            Pursue Your Higher Education In An American University
                        </Typography>
                        <Typography variant="h6" paragraph>
                            Complete Admissions Support to Study in America
                        </Typography>
                        <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
                            Get Started
                        </Button>
                    </Box>

                    {/* Tabs for Different Sections */}
                    <AppBar position="static" color="default">
                        <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
                            <Tab label="Why Migrate To The US?" />
                            <Tab label="In Usa" />
                            {/* <Tab label="Student Life" /> */}
                        </Tabs>
                    </AppBar>

                    {/* Tab Content */}
                    {value === 0 && (
                        <Box sx={{ padding: '5px 0' }}>
                            <br />
                            <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black' }}>
                                    Study In America
                                </Typography>
                            </Box>
                            <br />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black' }}>

                                End To End US Migration Support
                            </Typography>
                            <Typography variant="body1" paragraph>
                                The world’s leading superpower is also its greatest migration destination. The United States offers unmatched opportunity and an unparalleled quality of life for families and individuals. Its strong economy, excellent educational system and liberal way of life make it a bastion of progress and growth. At Allians International, we have extensive experience with the US immigration processes. Our teams have the knowledge and experience to help you get started with your American Dream.
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black' }}>

                                Why Migrate To The US?
                            </Typography>
                            <br />
                            <Grid container spacing={2} justifyContent="center">

                                {benefits.map((benefit, index) => (
                                    <Grid item xs={6} sm={6} md={6} key={index}>
                                        <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                                            <IconButton color="primary" sx={{ marginRight: '16px' }}>
                                                {benefit.icon}
                                            </IconButton>
                                            <CardContent sx={{ flex: 1 }}>
                                                <Typography variant="h6" gutterBottom>
                                                    {benefit.title}
                                                </Typography>
                                                {/* Uncomment below line if you want to include the description */}
                                                {/* <Typography variant="body2">{benefit.description}</Typography> */}
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    )}

                    {value === 1 && (
                        <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa' }}>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                                Admission Process
                            </Typography>
                            <Typography variant="body1" paragraph>
                                The admission process for studying in America typically includes the following steps:
                            </Typography>
                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {[
                                    "Choose a program and institution.",
                                    "Check the admission requirements.",
                                    "Prepare required documents (transcripts, letters of recommendation, etc.).",
                                    "Submit your application online.",
                                    "Receive an acceptance letter and pay tuition fees.",
                                    "Apply for a study permit.",
                                ].map((step, index) => (
                                    <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                                        <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                                        <Typography variant="body1">{step}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    )}

                    {value === 2 && (
                        <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                                Student Life
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Student life in America is diverse and vibrant. You can expect to engage in:
                            </Typography>
                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                {[
                                    "Participating in clubs and organizations.",
                                    "Attending social events and networking opportunities.",
                                    "Enjoying the cultural and recreational activities in your area.",
                                ].map((activity, index) => (
                                    <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                                        <EventIcon color="primary" style={{ marginRight: '10px' }} />
                                        <Typography variant="body1">{activity}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    )}

                    <Box sx={{ padding: '20px' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                            USA Immigration Process & Approach
                        </Typography>
                        <Divider sx={{ marginBottom: 2 }} />

                        <Typography variant="body1" paragraph>
                            The United States has a well-defined immigration process that attracts thousands of applications every year. At Allians, we have the experience and track record to help you create an application package with the highest chances of success. Your counsellor will assess your profile and help you identify the right immigration approach. There are numerous ways to migrate to the US which include:
                        </Typography>
                        <Divider sx={{ marginBottom: 2 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                            Migration Options:
                        </Typography>
                        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                            {[
                                "- Migrating to the US as an employee.",
                                "- Migrating to the US through the investor route.",
                                "- Migrating with your family to the US.",
                            ].map((option, index) => (
                                <li key={index} style={{ marginBottom: '10px' }}>
                                    <Typography variant="body1">{option}</Typography>
                                </li>
                            ))}
                        </ul>

                        <Divider sx={{ marginBottom: 2 }} />

                        <Typography variant="body1" paragraph>
                            Allians has been the immigration consultant of choice for serious migrants. Our professional approach and thorough research ensure your application is in good hands. Talk to us to discover how we can help you realise your ambition of migrating to the US.
                        </Typography>
                    </Box>
                    {/* FAQ Accordion */}
                    {/* <Box sx={{ marginTop: 4 }}>
                        <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                    Cost Of Studying In The USA
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                                <Box sx={{ padding: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        The US Universities fall under two major categories: public funded and private institutions. International students’ tuition expenses at state schools are based on non-resident costs,
                                        which are still usually less expensive than those of private universities.
                                        You will need approximately $10,000 to $55,000 annually to cover your tuition fees.
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                    Work Authorization for Students
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                                <Box sx={{ padding: 2 }}>
                                    <strong>STUDENT APPLICANT:</strong>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">Students must be over 18 years of age</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">International students can work on-campus up to 20 hours/week or less during the academic terms and full-time during the academic break periods including summer time</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1"> Off-campus employment requires some form of written or documented authorization
                                            issued by either the USCIS or OISS. And also, you must be currently in legal status and have been enrolled as an F-1 student in the US for a minimum of one academic year to be eligible for any form of off-campus employment</Typography>
                                    </Box>
                                    <strong>SPOUSE:</strong>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">Per U.S. government regulations, only married spouses can obtain a dependent visa status. The student, scholar or employee can add a dependent spouse to his or her record, and the spouse can then obtain a dependent visa status (F-2, J-2 or H-4).
                                            These dependent statuses do have certain restrictions.</Typography>
                                    </Box>

                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                    After You Graduate
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                                <Box sx={{ padding: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">F1 visa holders are eligible for up to 12 months of OPT (optional practical training) on completion of graduation. That means you can work for a year after you finish your studies
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">It is a temporary employment permission allowing students the opportunity to gain practical experience in their field of study</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                                        <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                                        <Typography variant="body1">After that, you’ll be required to apply for a work visa if you have to continue working in the US. You can remain in the US up to 60 days after the completion of your course even if you don’t have a job offer or haven’t applied for OPT</Typography>
                                    </Box>

                                </Box>
                            </AccordionDetails>
                        </Accordion>

                    </Box> */}

                    {/* Snackbar for user feedback */}
                    <Snackbar
                        open={snackbarOpen}
                        onClose={handleSnackbarClose}
                        message="Get Started button clicked!"
                        autoHideDuration={4000}
                    />
                </Container>
            </div>
            <Webfoot />
        </div>
    );
};

export default Rusa;